import type { FC } from 'react';

import { cn } from '@yanolja-rnd/nol-design-system';
import { IcArrowoneway, IcArrowroundtrip } from '@yanolja-rnd/nol-icons';

import type { VerticalProductItemProps } from '..';

interface TitleSectionProps {
  title: string | { tripType: 'round-trip' | 'one-way'; departureCity: string; arrivalCity: string };
  titleClassName?: string;
}

const isFlight = (
  title: VerticalProductItemProps['title'],
): title is { tripType: 'round-trip' | 'one-way'; departureCity: string; arrivalCity: string } =>
  typeof title === 'object' && !!title.tripType;

export const TitleSection: FC<TitleSectionProps> = ({ title, titleClassName }) => (
  <>
    {isFlight(title) ? (
      <div
        className={cn(
          'overflow-hidden typography-body-13-bold-line-clamp-1 pc:typography-subtitle-18-bold-line-clamp-1',
          titleClassName,
        )}
      >
        {title.departureCity}
        {title.tripType === 'round-trip' ? (
          <IcArrowroundtrip className="inline size-10 pc:size-18 mx-2" />
        ) : (
          <IcArrowoneway className="inline size-10 pc:size-18 mx-2" />
        )}
        {title.arrivalCity}
      </div>
    ) : (
      <div
        className={cn(
          'overflow-hidden typography-body-13-regular-line-clamp-1 pc:typography-subtitle-18-regular-line-clamp-1',
          titleClassName,
        )}
      >
        {title}
      </div>
    )}
  </>
);
